import { Link } from "react-router-dom";
import { latestComics } from "@/mocks/comics";

export default function LatestUpdates() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1 font-label">
              每日更新，精彩不断
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-label transition-colors whitespace-nowrap cursor-pointer"
          >
            更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-2.5">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span
                    className={`px-1.5 py-0.5 rounded text-[10px] font-label ${
                      comic.status === "连载"
                        ? "bg-accent-500 text-background-50"
                        : "bg-foreground-600 text-background-50"
                    }`}
                  >
                    {comic.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2.5">
                  <span className="text-[10px] text-background-50/90 font-label">
                    更新至 {comic.chapters} 话
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5 font-label">
                {comic.author}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}